const localizations = {

  'welcome-modal.help-research.email-title': 'Login space research',

  'analytics.label': 'Analytics',

  'navigation.creating.title': "Creating {name} project",
  'navigation.creating.subtitle': 'It may take some time.',

  /* чек-лист. В перевод отдавать только после переработкеи чек-листа под новый flow */
  'check-list.rest-steps.open-settings': 'set up checklist', //
  'check-list.rest-steps.open-settings.description': 'Configure main Login settings', //

  'settings.crumbs.login-type.social-login': 'Social Login',
  'settings.crumbs.login-type.shadow': 'Authentication',

  'settings.tabs.callback-url': 'Callback URLs',
  'settings.tabs.username': 'Username settings',
  'settings.tabs.email-validation': 'Email validation',
  'settings.tabs.login-settings': 'Login settings',

  'navigation.settings.signup-settings.title': 'Sign up settings',
  'navigation.settings.signup-settings.subtitle': 'Set up basic game information in different languages.',
  'navigation.settings.password-settings.title':'Password settings',
  'navigation.settings.password-settings.subtitle':'Set up Login settings that depend on a publishing platform.',
  'navigation.settings.username-settings.title':'Username settings',
  'navigation.settings.username-settings.subtitle':'Set up Login settings that depend on a publishing platform.',
  'navigation.settings.email-validation-settings.title':'Email validation',
  'navigation.settings.email-validation-settings.subtitle':'Set up Login settings that depend on a publishing platform.',

  'user-data-base.settings.tabs.additional-form': 'Additional form',

  // Метки, которые могут понадобиться при сбросе secret key
  'settings.signature.notification.old-key': 'You old key will be expired and disappeared in 48 hours. Please, change it before Login will be damage.', //
  'settings.signature.old-secret.label': 'Old secret key',

  'sms-customization.settings.mfa_code.placeholder2': 'Example: %s is your confirmation code for %s.',
  'sms-customization.settings.mfa_code.post-description2': 'The %s tags are automatically replaced with the real values. Do not try to enter real codes or names in this field.',

  // Для блока с обновлением версии старого виджета. Cейчас нигде не используется
  'widget-customization.old.updateNotifications.message': 'A new version of the Widget has been released. To get it, click the button below and follow the instructions.',
  'widget-customization.old.updateNotifications.title': 'Widget update available',
  'widget-customization.old.updateNotifications.updating-alert': "When updating, the custom styles will break. To customize a new version, follow the instructions below."

};

module.exports = localizations;
